angular.module('conferencesApp').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('views/admin-conference-detail.html',
    "<ol class=\"breadcrumb\">\n" +
    "    <li><a ui-sref=\"admin_conferences.list\">Conferences Admin</a></li>\n" +
    "    <li class=\"active\">{{title || \" \"}}</li>\n" +
    "</ol>\n" +
    "\n" +
    "<ws-alerts></ws-alerts>\n" +
    "\n" +
    "<h1>{{title || \" \"}}</h1>\n" +
    "\n" +
    "<ul class=\"nav nav-tabs\">\n" +
    "    <li ui-sref-active=\"active\"><a ui-sref=\"admin_conferences.conference.detail.sessions\">Sessions</a></li>\n" +
    "    <li ui-sref-active=\"active\"><a ui-sref=\"admin_conferences.conference.detail.speakers\">Speakers</a></li>\n" +
    "</ul>\n" +
    "\n" +
    "<div id=\"content\" ui-view>\n" +
    "</div>\n"
  );


  $templateCache.put('views/admin-conference-session-create.html',
    "<ol class=\"breadcrumb\">\n" +
    "    <li><a ui-sref=\"admin_conferences.list\">Conferences Admin</a></li>\n" +
    "    <li><a ui-sref=\"admin_conferences.conference.detail.sessions\">{{ conference.name.text }}</a></li>\n" +
    "    <li class=\"active\">Add Session</li>\n" +
    "</ol>\n" +
    "\n" +
    "<ws-alerts></ws-alerts>\n" +
    "\n" +
    "<h1>Add Session</h1>\n" +
    "\n" +
    "<hr/>\n" +
    "\n" +
    "<div id=\"content\" ui-view>\n" +
    "</div>\n"
  );


  $templateCache.put('views/admin-conference-session-files.html',
    "<p ng-show=\"userIsAdmin || canUpload\">\n" +
    "    <button type=\"button\" class=\"btn btn-default\" ngf-select=\"fieldUploadFiles($files, $invalidFiles)\" multiple>Upload file(s)</button>\n" +
    "</p>\n" +
    "<div class=\"panel panel-default\">\n" +
    "    <table class=\"table table-striped\">\n" +
    "        <tbody>\n" +
    "            <tr ng-repeat=\"file in session.files\">\n" +
    "                <td><a href=\"{{file.download}}\" target=\"_blank\" rel=\"noopener\">{{file.filename}}</a></td>\n" +
    "                <td class=\"text-right\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"deleteFile(file)\">Delete file</button></td>\n" +
    "            </tr>\n" +
    "            <tr ng-repeat=\"file in session.uploading | filter:{progress: '!100'}\">\n" +
    "                <td>{{file.name}} {{file.$errorParam}}</td>\n" +
    "                <td class=\"text-right\">{{file.progress}}%</td>\n" +
    "            </tr>\n" +
    "        </tbody>\n" +
    "    </table>\n" +
    "</div>\n"
  );


  $templateCache.put('views/admin-conference-session-form.html',
    "<form class=\"form-horizontal\" name=\"form\" novalidate focus-error ng-submit=\"save()\">\n" +
    "    <div class=\"form-group\" ng-class=\"{'has-error': submitted && form.title.$invalid}\">\n" +
    "        <label for=\"title\" class=\"col-sm-3 control-label\">Title <span class=\"required\">*</span></label>\n" +
    "        <div class=\"col-sm-4\">\n" +
    "            <input type=\"text\" class=\"form-control\" id=\"title\" name=\"title\" required ng-model=\"session.title.text\">\n" +
    "        </div>\n" +
    "        <div class=\"col-sm-5\">\n" +
    "            <span class=\"help-block\" ng-show=\"submitted\" ng-messages=\"form.title.$error\">\n" +
    "                <span ng-message=\"required\">Please enter a title!</span>\n" +
    "            </span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"form-group\">\n" +
    "        <label for=\"end\" class=\"col-sm-3 control-label\">Type <span class=\"required\">*</span></label>\n" +
    "        <div class=\"col-sm-4\">\n" +
    "            <select id=\"type\" name=\"type\" class=\"form-control\" ng-model=\"session.type\">\n" +
    "                <option value=\"presentation\">Presentation</option>\n" +
    "                <option value=\"lightning\">Lightning talk</option>\n" +
    "                <option value=\"panel\">Panel</option>\n" +
    "                <option value=\"keynote\">Keynote</option>\n" +
    "                <option value=\"roundtable\">Roundtable</option>\n" +
    "                <option value=\"workshop\">Workshop</option>\n" +
    "                <option value=\"workinggroup\">Working group</option>\n" +
    "                <option value=\"opening\">Opening session</option>\n" +
    "                <option value=\"closing\">Closing session</option>\n" +
    "                <option value=\"coffee\">Coffee</option>\n" +
    "                <option value=\"lunch\">Lunch</option>\n" +
    "                <option value=\"dinner\">Dinner</option>\n" +
    "                <option value=\"excursion\">Excursion</option>\n" +
    "            </select>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"form-group\" ng-class=\"{'has-error': submitted && form.description.$invalid}\">\n" +
    "        <label for=\"description\" class=\"col-sm-3 control-label\">Description</label>\n" +
    "        <div class=\"col-sm-6\">\n" +
    "            <textarea class=\"form-control\" id=\"bio\" name=\"bio\" rows=\"9\" ng-model=\"session.description.text\"></textarea>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"form-group\">\n" +
    "        <label for=\"start\" class=\"col-sm-3 control-label\">Start</label>\n" +
    "        <div class=\"col-sm-4\">\n" +
    "            <input type=\"text\" class=\"form-control\" id=\"start\" name=\"start\" ng-model=\"session.start\" placeholder=\"DD.MM.YYYY HH:MM\">\n" +
    "        </div>\n" +
    "        <div class=\"col-sm-5\">\n" +
    "            <span class=\"help-block\">GMT{{ now | amUtcOffset:(session.conference.utc_offset/60) | amDateFormat:'Z' }}</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"form-group\">\n" +
    "        <label for=\"end\" class=\"col-sm-3 control-label\">End</label>\n" +
    "        <div class=\"col-sm-4\">\n" +
    "            <input type=\"text\" class=\"form-control\" id=\"end\" name=\"end\" ng-model=\"session.end\" placeholder=\"DD.MM.YYYY HH:MM\">\n" +
    "        </div>\n" +
    "        <div class=\"col-sm-5\">\n" +
    "            <span class=\"help-block\">GMT{{ now | amUtcOffset:(session.conference.utc_offset/60) | amDateFormat:'Z' }}</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"form-group\">\n" +
    "        <label for=\"end\" class=\"col-sm-3 control-label\">Location</label>\n" +
    "        <div class=\"col-sm-4\">\n" +
    "            <select id=\"room\" name=\"room\" class=\"form-control\" ng-model=\"session.room\" ng-options=\"r.name.text for r in rooms.rooms track by r.id\">\n" +
    "                <option></option>\n" +
    "            </select>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"form-group\">\n" +
    "        <label for=\"end\" class=\"col-sm-3 control-label\">Track</label>\n" +
    "        <div class=\"col-sm-4\">\n" +
    "            <select id=\"track\" name=\"track\" class=\"form-control\" ng-model=\"session.track\" ng-options=\"t.name.text for t in tracks.tracks track by t.id\">\n" +
    "                <option></option>\n" +
    "            </select>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"form-group\">\n" +
    "        <label for=\"end\" class=\"col-sm-3 control-label\">Group</label>\n" +
    "        <div class=\"col-sm-4\">\n" +
    "            <select id=\"track\" name=\"track\" class=\"form-control\" ng-model=\"session.group\" ng-options=\"g.name.text for g in groups.groups track by g.id\">\n" +
    "                <option></option>\n" +
    "            </select>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"form-group\" ng-class=\"{'has-error': submitted && form.url_video.$invalid}\">\n" +
    "        <label for=\"url_video\" class=\"col-sm-3 control-label\">Video URL</label>\n" +
    "        <div class=\"col-sm-4\">\n" +
    "            <input type=\"text\" class=\"form-control\" id=\"url_video\" name=\"url_video\" ng-model=\"session.url_video\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"form-group\" ng-class=\"{'has-error': submitted && form.url_registration.$invalid}\">\n" +
    "        <label for=\"url_registration\" class=\"col-sm-3 control-label\">Registration URL</label>\n" +
    "        <div class=\"col-sm-4\">\n" +
    "            <input type=\"text\" class=\"form-control\" id=\"url_registration\" name=\"url_registration\" ng-model=\"session.url_registration\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"form-group\">\n" +
    "        <label for=\"image\" class=\"col-sm-3 control-label\">Image</label>\n" +
    "        <div class=\"col-sm-4\">\n" +
    "            <input type=\"file\" id=\"image\" name=\"image\" ngf-select=\"onFileSelect($files)\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"form-group\" ng-show=\"session.image\">\n" +
    "        <div class=\"col-sm-offset-3 col-sm-4\">\n" +
    "            <div class=\"ws-image-thumbnail\">\n" +
    "                <img ng-src=\"{{session.image.thumbnail}}_small\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"form-group\">\n" +
    "        <div class=\"col-sm-offset-3 col-sm-9\">\n" +
    "            <button type=\"submit\" class=\"btn btn-success\">Save<ws-text-spinner ng-show=\"loading\" class=\"ng-hide\"></ws-text-spinner></button>\n" +
    "            <a ui-sref=\"admin_conferences.conference.detail.sessions\" class=\"btn btn-default\">Cancel</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n"
  );


  $templateCache.put('views/admin-conference-session-migrate.html',
    "\n" +
    "<ws-alerts></ws-alerts>\n" +
    "\n" +
    "<p>\n" +
    "    <button type=\"button\" class=\"btn btn-default\" ng-click=\"migrate()\">Migrate</button>\n" +
    "</p>\n" +
    "<div class=\"panel panel-default\">\n" +
    "    <table class=\"table table-striped\">\n" +
    "        <tbody>\n" +
    "            <tr ng-repeat=\"file in files.files\">\n" +
    "                <td>{{file.id}}</td>\n" +
    "                <td>{{file.filename}}</td>\n" +
    "                <td>{{file.progress}}</td>\n" +
    "                <td>{{file.resource_id}}</td>\n" +
    "            </tr>\n" +
    "        </tbody>\n" +
    "    </table>\n" +
    "</div>\n"
  );


  $templateCache.put('views/admin-conference-session-speakers.html',
    "<p>\n" +
    "    <div class=\"btn-group\">\n" +
    "        <button type=\"button\" class=\"btn btn-success dropdown-toggle\" data-toggle=\"dropdown\">\n" +
    "            Add Speaker <span class=\"caret\"></span>\n" +
    "        </button>\n" +
    "        <ul class=\"dropdown-menu\">\n" +
    "            <li ng-repeat=\"speaker in availableSpeakers = (speakers.speakers | filter:{used:'!true'})\"><a href=\"javascript:\" ng-click=\"addSpeaker(speaker)\">{{speaker.first_name}} {{speaker.last_name}}</a></li>\n" +
    "            <li ng-show=\"availableSpeakers.length == 0\"><a href=\"javascript:\">No speakers available</a></li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "    <a class=\"btn btn-link\" ui-sref=\"admin_conferences.conference.speaker_create({sessionId: session.id})\">Add new Conference speaker</a>\n" +
    "</p>\n" +
    "\n" +
    "<div class=\"table-responsive\">\n" +
    "    <table class=\"table table-striped\">\n" +
    "        <colgroup>\n" +
    "            <col width=\"5%\" />\n" +
    "            <col width=\"95%\" />\n" +
    "        </colgroup>\n" +
    "        <thead>\n" +
    "            <tr>\n" +
    "                <th>&nbsp;</th>\n" +
    "                <th>Speaker</th>\n" +
    "            </tr>\n" +
    "        </thead>\n" +
    "        <tfoot><tr><td colspan=\"2\"></td></tr></tfoot>\n" +
    "        <tbody>\n" +
    "            <tr ng-repeat=\"speaker in session.speakers\">\n" +
    "                <td>\n" +
    "                    <input type=\"checkbox\" ng-model=\"speaker.checked\">\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                    <a ui-sref=\"admin_conferences.conference.speaker({speakerId: speaker.id})\">{{speaker.first_name}} {{speaker.last_name}}</a>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr ng-show=\"session.speakers.length == 0\">\n" +
    "                <td>&nbsp;</td>\n" +
    "                <td>No speakers found.</td>\n" +
    "            </tr>\n" +
    "        </tbody>\n" +
    "    </table>\n" +
    "</div>\n" +
    "<button type=\"button\" class=\"btn btn-danger\" ng-click=\"removeSpeakers()\">Remove selected</button>\n"
  );


  $templateCache.put('views/admin-conference-session.html',
    "<ol class=\"breadcrumb\">\n" +
    "    <li><a ui-sref=\"admin_conferences.list\">Conferences Admin</a></li>\n" +
    "    <li><a ui-sref=\"admin_conferences.conference.detail.sessions\">{{ conference.name.text }}</a></li>\n" +
    "    <li class=\"active\">{{id ? (title || \" \") : \"Add Session\"}}</li>\n" +
    "</ol>\n" +
    "\n" +
    "<ws-alerts></ws-alerts>\n" +
    "\n" +
    "<p class=\"pull-right\">\n" +
    "    <button ng-click=\"deleteSession()\" class=\"btn btn-danger\">Delete Session<ws-text-spinner ng-show=\"deleteLoading\" class=\"ng-hide\"></ws-text-spinner></button>\n" +
    "</p>\n" +
    "\n" +
    "<h1>{{id ? (title || \" \") : \"Add Session\"}}</h1>\n" +
    "\n" +
    "<ul class=\"nav nav-tabs\">\n" +
    "    <li ui-sref-active=\"active\"><a ui-sref=\"admin_conferences.conference.session.form\">Session</a></li>\n" +
    "    <li ui-sref-active=\"active\"><a ui-sref=\"admin_conferences.conference.session.speakers\">Speakers</a></li>\n" +
    "    <li ui-sref-active=\"active\"><a ui-sref=\"admin_conferences.conference.session.files\">Files</a></li>\n" +
    "</ul>\n" +
    "\n" +
    "<div id=\"content\" ui-view>\n" +
    "</div>\n"
  );


  $templateCache.put('views/admin-conference-sessions.html',
    "<p class=\"pull-right\">\n" +
    "    <a ui-sref=\"admin_conferences.conference.session_create.form\" class=\"btn btn-success\">Add Session</a>\n" +
    "</p>\n" +
    "\n" +
    "<h2 class=\"clearfix\">Sessions</h2>\n" +
    "\n" +
    "<div class=\"table-responsive\">\n" +
    "    <table class=\"table table-striped\">\n" +
    "        <colgroup>\n" +
    "            <col width=\"40%\" />\n" +
    "            <col width=\"10%\" />\n" +
    "            <col width=\"15%\" />\n" +
    "            <col width=\"15%\" />\n" +
    "            <col width=\"20%\" />\n" +
    "        </colgroup>\n" +
    "        <thead>\n" +
    "            <tr>\n" +
    "                <th>Title</th>\n" +
    "                <th>Type</th>\n" +
    "                <th>Start</th>\n" +
    "                <th>End</th>\n" +
    "                <th>Location</th>\n" +
    "            </tr>\n" +
    "        </thead>\n" +
    "        <tfoot><tr><td colspan=\"5\"></td></tr></tfoot>\n" +
    "        <tbody>\n" +
    "            <tr ng-repeat=\"session in sessions.sessions\">\n" +
    "                <td><a ui-sref=\"admin_conferences.conference.session.form({sessionId: session.id})\">{{ session.title.text }}</a></td>\n" +
    "                <td>{{ session.type|ucfirst }}</td>\n" +
    "                <td>{{ session.start | amUtcOffset:(session.conference.utc_offset/60) | amDateFormat:'D MMMM YYYY HH:mm' }}</td>\n" +
    "                <td>{{ session.end | amUtcOffset:(session.conference.utc_offset/60) | amDateFormat:'D MMMM YYYY HH:mm' }}</td>\n" +
    "                <td>{{ session.room.name.text }}</td>\n" +
    "            </tr>\n" +
    "            <tr ng-show=\"sessions.sessions.length == 0\">\n" +
    "                <td colspan=\"5\">No sessions found.</td>\n" +
    "            </tr>\n" +
    "        </tbody>\n" +
    "    </table>\n" +
    "</div>\n"
  );


  $templateCache.put('views/admin-conference-speaker.html',
    "<ol class=\"breadcrumb\">\n" +
    "    <li><a ui-sref=\"admin_conferences.list\">Conferences Admin</a></li>\n" +
    "    <li><a ui-sref=\"admin_conferences.conference.detail.sessions\">{{ conference.name.text }}</a></li>\n" +
    "    <li><a ui-sref=\"admin_conferences.conference.detail.speakers\">Speakers</a></li>\n" +
    "    <li class=\"active\">{{id ? (title || \" \") : \"Add Speaker\"}}</li>\n" +
    "</ol>\n" +
    "\n" +
    "<ws-alerts></ws-alerts>\n" +
    "\n" +
    "<p class=\"pull-right\">\n" +
    "    <button ng-click=\"deleteSpeaker()\" class=\"btn btn-danger\">Delete Speaker<ws-text-spinner ng-show=\"deleteLoading\" class=\"ng-hide\"></ws-text-spinner></button>\n" +
    "</p>\n" +
    "\n" +
    "<h1>{{id ? (speakerTitle || \" \") : \"Add Speaker\"}}</h1>\n" +
    "\n" +
    "<hr>\n" +
    "\n" +
    "<div id=\"content\">\n" +
    "    <form class=\"form-horizontal\" name=\"form\" novalidate focus-error ng-submit=\"save()\">\n" +
    "        <div class=\"form-group\" ng-class=\"{'has-error': submitted && form.first_name.$invalid}\">\n" +
    "            <label for=\"first_name\" class=\"col-sm-3 control-label\">First name <span class=\"required\">*</span></label>\n" +
    "            <div class=\"col-sm-4\">\n" +
    "                <input type=\"text\" class=\"form-control\" id=\"first_name\" name=\"first_name\" required ng-model=\"speaker.first_name\">\n" +
    "            </div>\n" +
    "            <div class=\"col-sm-5\">\n" +
    "                <span class=\"help-block\" ng-show=\"submitted\" ng-messages=\"form.first_name.$error\">\n" +
    "                    <span ng-message=\"required\">Please enter a first name!</span>\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"form-group\" ng-class=\"{'has-error': submitted && form.last_name.$invalid}\">\n" +
    "            <label for=\"last_name\" class=\"col-sm-3 control-label\">Last name <span class=\"required\">*</span></label>\n" +
    "            <div class=\"col-sm-4\">\n" +
    "                <input type=\"text\" class=\"form-control\" id=\"last_name\" name=\"last_name\" required ng-model=\"speaker.last_name\">\n" +
    "            </div>\n" +
    "            <div class=\"col-sm-5\">\n" +
    "                <span class=\"help-block\" ng-show=\"submitted\" ng-messages=\"form.last_name.$error\">\n" +
    "                    <span ng-message=\"required\">Please enter a last name!</span>\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"form-group\">\n" +
    "            <label for=\"person_id\" class=\"col-sm-3 control-label\">WorldSkills Person ID</label>\n" +
    "            <div class=\"col-sm-4\">\n" +
    "                <input type=\"text\" class=\"form-control\" id=\"person_id\" name=\"person_id\" ng-model=\"speaker.person_id\">\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <hr/>\n" +
    "        <div class=\"form-group\">\n" +
    "            <label for=\"company\" class=\"col-sm-3 control-label\">Company</label>\n" +
    "            <div class=\"col-sm-4\">\n" +
    "                <input type=\"text\" class=\"form-control\" id=\"company\" name=\"company\" ng-model=\"speaker.company\">\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"form-group\">\n" +
    "            <label for=\"position\" class=\"col-sm-3 control-label\">Position</label>\n" +
    "            <div class=\"col-sm-4\">\n" +
    "                <input type=\"text\" class=\"form-control\" id=\"position\" name=\"position\" ng-model=\"speaker.position\">\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <hr/>\n" +
    "        <div class=\"form-group\">\n" +
    "            <label for=\"photo\" class=\"col-sm-3 control-label\">Photo</label>\n" +
    "            <div class=\"col-sm-4\">\n" +
    "                <input type=\"file\" id=\"photo\" name=\"photo\" ngf-select=\"onFileSelect($files)\">\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"form-group\" ng-show=\"speaker.photo\">\n" +
    "            <div class=\"col-sm-offset-3 col-sm-4\">\n" +
    "                <div class=\"ws-image-thumbnail\">\n" +
    "                    <img ng-src=\"{{speaker.photo.thumbnail}}_small\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"form-group\" ng-class=\"{'has-error': submitted && form.bio.$invalid}\">\n" +
    "            <label for=\"bio\" class=\"col-sm-3 control-label\">Bio</label>\n" +
    "            <div class=\"col-sm-6\">\n" +
    "                <textarea class=\"form-control\" id=\"bio\" name=\"bio\" rows=\"9\" ng-model=\"speaker.bio.text\"></textarea>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"form-group\">\n" +
    "            <div class=\"col-sm-offset-3 col-sm-9\">\n" +
    "                <button type=\"submit\" class=\"btn btn-success\">Save<ws-text-spinner ng-show=\"loading\" class=\"ng-hide\"></ws-text-spinner></button>\n" +
    "                <a ng-if=\"sessionId\" ui-sref=\"admin_conferences.conference.session.speakers({sessionId: sessionId})\" class=\"btn btn-default\">Cancel</a>\n" +
    "                <a ng-if=\"!sessionId\" ui-sref=\"admin_conferences.conference.detail.speakers\" class=\"btn btn-default\">Cancel</a>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </form>\n" +
    "</div>\n"
  );


  $templateCache.put('views/admin-conference-speakers.html',
    "<p class=\"pull-right\">\n" +
    "    <a ui-sref=\"admin_conferences.conference.speaker_create\" class=\"btn btn-success\">Add Speaker</a>\n" +
    "</p>\n" +
    "\n" +
    "<h2 class=\"clearfix\">Speakers</h2>\n" +
    "\n" +
    "<div class=\"table-responsive\">\n" +
    "    <table class=\"table table-striped\">\n" +
    "        <colgroup>\n" +
    "            <col width=\"5%\" />\n" +
    "            <col width=\"25%\" />\n" +
    "            <col width=\"25%\" />\n" +
    "            <col width=\"25%\" />\n" +
    "            <col width=\"20%\" />\n" +
    "        </colgroup>\n" +
    "        <thead>\n" +
    "            <tr>\n" +
    "                <th>&nbsp;</th>\n" +
    "                <th>Name</th>\n" +
    "                <th>Company</th>\n" +
    "                <th>Position</th>\n" +
    "                <th>Bio</th>\n" +
    "            </tr>\n" +
    "        </thead>\n" +
    "        <tfoot><tr><td colspan=\"5\"></td></tr></tfoot>\n" +
    "        <tbody>\n" +
    "            <tr ng-repeat=\"speaker in speakers.speakers\">\n" +
    "                <td>\n" +
    "                    <div ng-show=\"speaker.photo\">\n" +
    "                        <img ng-src=\"{{speaker.photo.thumbnail}}_small\" height=\"16\">\n" +
    "                    </div>\n" +
    "                </td>\n" +
    "                <td><a ui-sref=\"admin_conferences.conference.speaker({speakerId: speaker.id})\">{{ speaker.first_name }} {{ speaker.last_name }}</a></td>\n" +
    "                <td>{{ speaker.company }}</td>\n" +
    "                <td>{{ speaker.position }}</td>\n" +
    "                <td>{{ speaker.bio.text }}</td>\n" +
    "            </tr>\n" +
    "            <tr ng-show=\"speakers.speakers.length == 0\">\n" +
    "                <td colspan=\"5\">No speakers found.</td>\n" +
    "            </tr>\n" +
    "        </tbody>\n" +
    "    </table>\n" +
    "</div>\n"
  );


  $templateCache.put('views/admin-conference.html',
    "<div ui-view></div>\n"
  );


  $templateCache.put('views/admin-conferences-list.html',
    "<ol class=\"breadcrumb\">\n" +
    "    <li>Conferences Admin</li>\n" +
    "</ol>\n" +
    "\n" +
    "<h1>Conferences Admin</h1>\n" +
    "\n" +
    "<hr />\n" +
    "\n" +
    "<table class=\"table table-striped\">\n" +
    "    <colgroup>\n" +
    "        <col width=\"10%\" />\n" +
    "        <col width=\"90%\" />\n" +
    "    </colgroup>\n" +
    "    <thead>\n" +
    "        <tr>\n" +
    "            <th>ID</th>\n" +
    "            <th>Name</th>\n" +
    "        </tr>\n" +
    "    </thead>\n" +
    "    <tfoot>\n" +
    "        <tr ng-show=\"!loading\"><td colspan=\"2\"></td></tr>\n" +
    "    </tfoot>\n" +
    "    <tbody>\n" +
    "        <tr ng-repeat=\"conference in conferences.conferences\">\n" +
    "            <td><a ui-sref=\"admin_conferences.conference.detail.sessions({conferenceId: conference.id})\">{{conference.id}}</a></td>\n" +
    "            <td><a ui-sref=\"admin_conferences.conference.detail.sessions({conferenceId: conference.id})\">{{conference.name.text}}</a></td>\n" +
    "        </tr>\n" +
    "        <tr ng-show=\"!loading && conferences.total_count == 0\">\n" +
    "            <td colspan=\"2\">No conferences found.</td>\n" +
    "        </tr>\n" +
    "        <tr ng-show=\"loading\">\n" +
    "            <td colspan=\"2\"><ws-spinner></ws-spinner></td>\n" +
    "        </tr>\n" +
    "    </tbody>\n" +
    "</table>\n"
  );


  $templateCache.put('views/admin-conferences.html',
    "<div ui-view></div>\n"
  );


  $templateCache.put('views/wsalert.html',
    "<div id=\"ws-alert-scroll-anchor\"></div>\n" +
    "<uib-alert ng-repeat=\"message in WSAlert.messages\" type=\"message.type\" close=\"close($index)\" class=\"alert alert-{{message.type}}\"><strong ng-show=\"message.title.length > 0\">{{message.title}} </strong>{{message.text}}</uib-alert>\n"
  );

}]);
